import styled from 'styled-components';
import { Avatar } from 'ui/avatar';
import { Ellipse } from 'ui/icons';
import { colors, fontSizes, spacing } from 'ui/theme';
import { BottomTooltip } from 'ui/tooltip';
import { timestampToShortDateHourMin } from 'utils/date';
import { getNameDetails } from '../utils';

const MemberDataContainer = styled.section`
  align-items: center;
  display: flex;
  gap: ${spacing.half};
`;

const MemberData = styled.span`
  &:first-of-type {
    flex-shrink: 0;
  }
  align-items: center;
  color: ${colors.grey50};
  display: flex;
  font-size: ${fontSizes.s12};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

type Props = {
  avatarUrl?: string;
  firstName?: string;
  lastName?: string;
  memberId?: string | number;
  displayTemplateType?: string;
  updatedAt?: string;
  updatedFromNow?: string;
};

export const MemberDetails = ({
  avatarUrl,
  firstName = '',
  lastName = '',
  memberId = '',
  updatedAt,
  updatedFromNow,
  displayTemplateType,
}: Props) => {
  const { firstName: safeFirstName, lastName: safeLastName } = getNameDetails(
    firstName || '',
    lastName || '',
  );

  const fullName = `${safeFirstName || ''} ${safeLastName || ''}`.trim();

  return (
    <MemberDataContainer data-test="template-list-item-member-details">
      {!!safeFirstName && (
        <>
          <BottomTooltip
            tooltipContent={
              <div>
                <div>{fullName}</div>
                <div>{memberId}</div>
              </div>
            }
          >
            <MemberData>
              <Avatar imgSrc={avatarUrl} firstName={firstName || ''} lastName={lastName || ''} />
            </MemberData>
          </BottomTooltip>
          <Ellipse width={3} height={3} />
        </>
      )}

      <BottomTooltip tooltipContent={timestampToShortDateHourMin(updatedAt || '')}>
        <MemberData>Edited {updatedFromNow}</MemberData>
      </BottomTooltip>

      {!!displayTemplateType && (
        <>
          <Ellipse width={3} height={3} />
          <MemberData>{displayTemplateType}</MemberData>
        </>
      )}
    </MemberDataContainer>
  );
};
